import { makeStyles } from '@material-ui/core/styles';

export const LABEL_CLASS = 'label';
export const LABEL_GREY_CLASS = 'labelGray';
export const LABEL_INFO_CLASS = 'labelInfo';
export const LABEL_WARNING_CLASS = 'labelWarning';
export const LABEL_ERROR_CLASS = 'labelError';
export const POE_WARNING_CLASS = 'poeWarning';
export const WIFI_STATUS_ICON_CONTAINER_CLASS = 'wifiStatusIconContainer';
export const WIFI_STATUS_ICON_CLASS = 'wifiStatusIcon';
export const WIRED_STATUS_ICON_CONTAINER_CLASS = 'wiredStatusIconContainer';
export const WIRED_STATUS_ICON_CLASS = 'wiredStatusIcon';
export const STATUS_ICON_CONTAINER_CLASS = 'statusIconContainer';
export const STATUS_ICON_CLASS = 'statusIcon';
export const WIFI_SUCCESS = 'wifiSuccess';
export const WIFI_FAIL = 'wifiFail';
export const WIFI_OFF = 'wifiOff';
export const WIRED_SUCCESS = 'wiredSuccess';
export const WIRED_FAIL = 'wiredFail';
export const WIRED_OFF = 'wiredOff';
export const MATCHING_SITES_CONTAINER_CLASS = 'matchingSitesContainer';
export const MORE_SITES_ICON_CLASS = 'moreSitesIcon';

export const useColumnStyles = makeStyles((theme) => ({
    root: {
        [`& .${WIFI_STATUS_ICON_CONTAINER_CLASS}`]: {
            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.flexDirectionRow,
            ...theme.mixins.flex.alignItemsCenter,
            [`& .${WIFI_STATUS_ICON_CLASS}`]: {
                paddingRight: 10,
                '& svg': {
                    ...theme.mixins.flex.displayFlex,
                    ...theme.mixins.flex.alignItemsCenter,
                    fontSize: 18,
                },
            },
            [`& .${WIFI_SUCCESS}`]: {
                color: theme.palette.status.green,
            },
            [`& .${WIFI_FAIL}`]: {
                color: theme.palette.status.red,
            },
            [`& .${WIFI_OFF}`]: {
                color: theme.palette.status.gray,
            },
        },
        [`& .${STATUS_ICON_CONTAINER_CLASS}`]: {
            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.flexDirectionRow,
            ...theme.mixins.flex.alignItemsCenter,
            [`& .${STATUS_ICON_CLASS}`]: {
                paddingLeft: 10,
                '& svg': {
                    ...theme.mixins.flex.displayFlex,
                    ...theme.mixins.flex.alignItemsCenter,
                    fontSize: 18,
                },
            },
        },
        [`& .${POE_WARNING_CLASS}`]: {
            color: theme.palette.alert.warning,
        },
        [`& .${LABEL_CLASS}`]: {
            borderRadius: 3,
            display: 'inline-block',
            padding: '2px 4px',
            fontSize: 12,
            fontWeight: 'bold',
            color: '#FFFFFF',
            lineHeight: '14px',
            verticalAlign: 'baseline',
            whiteSpace: 'nowrap',
            textShadow: '0 -1px 0 rgba(0, 0, 0, 0.25)',
            backgroundColor: '#999999',
        },
        [`& .${LABEL_INFO_CLASS}`]: {
            backgroundColor: theme.palette.alert.info,
        },
        [`& .${LABEL_WARNING_CLASS}`]: {
            backgroundColor: theme.palette.alert.warning,
        },
        [`& .${LABEL_ERROR_CLASS}`]: {
            backgroundColor: theme.palette.alert.error,
        },
        [`& .${LABEL_GREY_CLASS}`]: {
            backgroundColor: theme.palette.status.gray,
        },
        [`& .${MATCHING_SITES_CONTAINER_CLASS}`]: {
            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.flexDirectionRow,
            ...theme.mixins.flex.alignItemsCenter,
            [`& .${MORE_SITES_ICON_CLASS}`]: {
                paddingLeft: 10,
                '& svg': {
                    ...theme.mixins.flex.displayFlex,
                    ...theme.mixins.flex.alignItemsCenter,
                    fontSize: 18,
                },
            },
        },
    },
}));

export const useDetailStyles = makeStyles((theme) => ({
    genericSelect: {
        '& .MuiSelect-select': {
            minWidth: 300,
        },
    },
    beaconSelect: {
        '& .MuiSelect-select': {
            minWidth: 390,
        },
    },
    globalAgentOverloadedWarning: {
        '& .MuiSvgIcon-root': {
            paddingTop: 10,
            verticalAlign: 'baseline',
            color: theme.palette.alert.warning,
        },
        fontWeight: 500,
    },
    cryptoPolicy: {
        '& .MuiInput-input': {
            minWidth: 300,
        },
    },
    cryptoModules: {
        '& input': {
            minWidth: 350,
        },
    },
}));

export const useHealthStyles = makeStyles((theme) => ({
    chartsContainer: {
        marginBottom: theme.spacing(6),
    },
    timeRangeSelect: {
        '& .MuiSelect-select': {
            minWidth: 120,
        },
    },
}));
